import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { FormBuilder } from '@angular/forms';

import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ConnService } from '../../conn.service';
import { URLAPI, HTTPOPTION } from '../../app.conn';

import {MatDialog} from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';

// import { ModalComponent } from './modal.component';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';

import { QUIZ_battel_result, QUIZ_tscore_result } from '../quiz';

@Component({
  selector: 'app-quizdetail',
  templateUrl: './quizdetail.component.html',
  styleUrls: ['../index/index.component.css']
})

export class QuizdetailComponent implements OnInit {

  constructor(
    private _route: ActivatedRoute,
    private _http: HttpClient,
    private _form: FormBuilder,
    private _conn: ConnService,
    public dialog: MatDialog,
    private overlay: Overlay,
    private modalService: NgbModal
  ) { }

  qid:string;
  URLAPI:string;
  HTTPOPTION:any;
  authorizationData:any;
  loading = false;

  letters:any = ['A', 'B', 'C', 'D', 'E', 'P', 'Q', 'R', 'S', 'T'];

  timer:any;
  count_sec = 5;

  ngOnInit(): void {

    this.URLAPI = URLAPI;
    this.HTTPOPTION = HTTPOPTION;
    this.authorizationData = this._conn.authorizationData();

    let sub = this._route.params.subscribe(params => {
      this.qid = params['qid'];
    });
    // alert(this.qid);
    this.quizDetail(this.qid);

  }

  triggerModal(content) {
    this.modalService.open(content, { size: 'xl' });

    // this.modalService.open(content, {ariaLabelledBy: 'modal-lg-resultSeq', size: 'xl'}).result.then((res) => {
    //   // this.closeModal = `Closed with: ${res}`;
    // }, (res) => {
    //   // this.closeModal = `Dismissed ${this.getDismissReason(res)}`;
    // });
  }

  quiz_detail:any;
  quiz_event:any = {"bg":"https://dummyimage.com/200x200/eee/999"};
  solutionCnt:number = 0;

  async quizDetail(qid){
    this.loading = true;
    let api = 't2/instructorQuizDetail/'+qid;
    let url = this.URLAPI + api;

    //{ withCredentials: true, credentials: 'include' }

    let response = await this._http
      .get(url, this.HTTPOPTION )
      .pipe()
      .toPromise();

    // let response = {"data":{"quiz":{"quiz_event":{"id":"2096","chapter_id":"1455","name":"64N Day1\/8 ทักษะคณิต 17.30-19.30  Nov02 , Open Course","description":"ทักษะคณิต","flag":"1","created_time":"2021-11-02","bg":"assets\/quiz_bg\/50.jpg","dateTh":"อังคารที่ 02 พ.ย.64"},"quiz_detail":[{"seq":"1","flag":true,"note":"","sol":"T","sol2":"","sol3":"T","quiz_id":2096,"quiz_type":true,"letters":"-","id":"120566"},{"seq":"2","flag":false,"note":"","sol":"20","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120567"},{"seq":"3","flag":false,"note":"","sol":"61","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120568"},{"seq":"4","flag":false,"note":"","sol":"61","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120569"},{"seq":"5","flag":false,"note":"","sol":"-18","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120570"},{"seq":"6","flag":false,"note":"","sol":"1","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120571"},{"seq":"7","flag":false,"note":"","sol":"115","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120572"},{"seq":"8","flag":false,"note":"","sol":"0.4","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120573"},{"seq":"9","flag":false,"note":"","sol":"17","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120574"},{"seq":"10","flag":false,"note":"","sol":"3\/4","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120575"},{"seq":"11","flag":false,"note":"","sol":"3\/4","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120576"},{"seq":"12","flag":false,"note":"","sol":"8","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120577"},{"seq":"13","flag":false,"note":"","sol":"16","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120578"},{"seq":"14","flag":false,"note":"","sol":"2","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120579"},{"seq":"15","flag":false,"note":"","sol":"6","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120580"},{"seq":"16","flag":false,"note":"","sol":"1650","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120581"},{"seq":"17","flag":false,"note":"","sol":"50","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120582"},{"seq":"18","flag":false,"note":"","sol":"9140","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120583"},{"seq":"19","flag":false,"note":"","sol":"9220","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120584"},{"seq":"20","flag":false,"note":"","sol":"9280","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120585"},{"seq":"21","flag":false,"note":"","sol":"9150","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120586"},{"seq":"22","flag":false,"note":"","sol":"B","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120587"},{"seq":"23","flag":false,"note":"","sol":"9140","sol2":"","sol3":"","quiz_id":2096,"quiz_type":false,"letters":"-","id":"120588"},{"seq":"24","flag":false,"note":null,"sol":"","sol2":null,"sol3":null,"quiz_id":2096,"quiz_type":false,"letters":"-","id":"120589"},{"seq":"25","flag":false,"note":null,"sol":"","sol2":null,"sol3":null,"quiz_id":2096,"quiz_type":false,"letters":"-","id":"120590"},{"seq":"26","flag":false,"note":null,"sol":"","sol2":null,"sol3":null,"quiz_id":2096,"quiz_type":false,"letters":"-","id":"120591"},{"seq":"27","flag":false,"note":null,"sol":"","sol2":null,"sol3":null,"quiz_id":2096,"quiz_type":false,"letters":"-","id":"120592"},{"seq":"28","flag":false,"note":null,"sol":"","sol2":null,"sol3":null,"quiz_id":2096,"quiz_type":false,"letters":"-","id":"120593"},{"seq":"29","flag":false,"note":null,"sol":"","sol2":null,"sol3":null,"quiz_id":2096,"quiz_type":false,"letters":"-","id":"120594"},{"seq":"30","flag":false,"note":null,"sol":"","sol2":null,"sol3":null,"quiz_id":2096,"quiz_type":false,"letters":"-","id":"120595"}],"solutionCnt":1}},"check":{"login":true,"user_id":"9163","user":"morgan","is_staff":"0","instructor_id":"25","fullname":"Ms.Morgan Calahan","nickname":"Morgan EP","sid":"morgan","ops_teacher_name":"t006"},"qid":2096,"action":"T2instructorQuizDetailAction"};

    let data = response['data']['quiz'];
    let quiz_detail = data['quiz_detail'];
    let quiz_event = data['quiz_event'];
    let solutionCnt = data['solutionCnt'];

    this.quiz_detail = quiz_detail;
    this.quiz_event = quiz_event;
    this.solutionCnt = solutionCnt;

    this.countSolution();
    this.loading = false;

    // this.StartTimer(this.count_sec, 0);
    // console.log(quiz_detail);
  }

  async saveEvent(){
    this.loading = true;
    let api = 't2/instructorQuizEventSave';
    let url = this.URLAPI + api;
    let formData = this.quiz_event;

    //{ withCredentials: true, credentials: 'include' }
    let response = await this._http
      .post(url, formData, this.HTTPOPTION )
      .pipe()
      .toPromise();
    this.loading = false;
  }

  async updateSolution(i){
    this.loading = true;
    let dataPost = this.quiz_detail[i];
    // console.warn(dataPost);

    this.stTrue = [];
    this.showTeacher = false;

    let api = 't2/instructorupdateSolutionQuiz';
    let url = this.URLAPI + api;
    let formData = this.quiz_event;

    let response = await this._http
      .post(url, dataPost, this.HTTPOPTION )
      .pipe()
      .toPromise();

      this.getResultQuizSeq(dataPost);
      this.loading = false;
  }

  updateFlagWriting(i, ev){
    let dataPost = this.quiz_detail[i];
    if( dataPost["quiz_type"] ){
      this.quiz_detail[i]["sol3"] = this.quiz_detail[i]["sol"];
      this.quiz_detail[i]["sol"] = 'T';
    }

    this.updateFlagOk(i, ev);
  }

  updateFlag(i, ev){
    let sec = this.count_sec;
    let dataPost = this.quiz_detail[i];

    // console.log(sec + ' | ' + this.count_sec );
    if( !dataPost['flag'] ){
      this.StartTimer(sec, i, ev);
    }else{
      this.updateFlagOk(i, ev);
    }
    // this.updateFlagOk(i, ev);
  }

  async updateFlagOk(i, ev){
    // alert(i);

    this.loading = true;
    let dataPost = this.quiz_detail[i];

    // console.warn(dataPost);
    let api = 't2/instructorUpdateFlagQuizSeq';
    let url = this.URLAPI + api;

    let response = await this._http
      .post(url, dataPost, this.HTTPOPTION )
      .pipe()
      .toPromise();

      this.countSolution();
      this.loading = false;
  }

  countSolution(){
    let quiz_detail = this.quiz_detail;
    let solutionCnt = 0;
    let letters = this.letters;
    let i = 0;
    quiz_detail.forEach( (obj, index) => {
      if(obj['flag'] === true){
        this.quiz_detail[index]['letters'] = letters[i];
        solutionCnt++
        i++;
      }else{
        this.quiz_detail[index]['letters'] = '';
      }
    });
    this.solutionCnt = solutionCnt;
  }

  closeAllSeq(){
    // console.warn('closeAllSeqOK');
    let sec = this.count_sec;
    this.secAll = sec
    this.StartTimerCloseAll(sec);
  }

  secAll=0;
  StartTimerCloseAll(sec){
    // console.warn('StartTimerCloseAll' + sec);
    this.timer = setTimeout(x =>
      {
          sec -= 1;
          if(sec >= 0){
            this.StartTimerCloseAll( sec ); // นับต่อ
            this.secAll = sec
          } else {
              // นับเสร็จแล้ว
              // console.warn('Sent Update AllFlag');
              this.closeAllSeqOK();
          }
      }, 1000);
      // this.quiz_detail[index]['letters'] = sec;
  }

  async closeAllSeqOK(){
    this.loading = true;
    // alert('closeAllSeq');
    let quiz_detail =  this.quiz_detail;
    quiz_detail.forEach( (obj, index) => {
       if(obj['flag'] === true){
        this.quiz_detail[index]['flag'] = false;
        this.quiz_detail[index]['letters'] = '';
       }
    });

    let api = 't2/instructorcloseAllSeq';
    let url = this.URLAPI + api+'/'+this.qid;

    let response = await this._http
      .get(url, this.HTTPOPTION )
      .pipe()
      .toPromise();

    this.countSolution();
    this.loading = false;

  }

  card:any = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15];
  stList:any;
  stTrue:any;
  stWrong:any;
  stStat:{} = {'right':0, 'wrong': 0, 'wait': 0, 'total': 0}
  QD:any = {'name':'', 'quiz_seq':''};
  stWait:any;

  async getResultQuizSeq(data){
    this.loading = true;
    console.log('getResultQuizSeq');
    let quiz_id = data['quiz_id'];
    let seq = data['seq'];

    let api = 't2/instructorQuizSeqDetail';
    let url = this.URLAPI + api+'/'+quiz_id+'/'+seq;


    //{ withCredentials: true, credentials: 'include' }
    let response = await this._http
      .get(url, this.HTTPOPTION )
      .pipe()
      .toPromise();

    let result = response['data'];

    let stList = result['stList'];
    let stTrue = result['stTrue'];
    let stWrong = result['stWrong'];
    let stWait = result['stWait'];
    let stStat = result['stStat'];
    let QD = result['QD'];

    // console.log(result);

    this.stTrue = stTrue;
    this.stList = stList;
    this.stWrong = stWrong;
    this.stWait = stWait;
    this.stStat = stStat;
    this.QD = QD;

    this.loading = false;

  }

  showTeacher = false;
  showTeacherData(){
    if(this.showTeacher == false){
      this.showTeacher = true;
    }else{
      this.showTeacher = false;
    }
  }

  quiz_battel_result = [];
  student_tscore_result = [];

  async quizDetailToday(){
    this.loading = true;

    let qid = this.qid;
    console.log('quizDetailToday: '+qid);

    let api = 't2/instructorQuizDetailToday';
    let url = this.URLAPI + api+'/'+qid;


    //{ withCredentials: true, credentials: 'include' }
    let response = await this._http
      .get(url, this.HTTPOPTION )
      .pipe()
      .toPromise();

    let result = response['data'];
    // console.warn(result);
    let quizDetail = result['quiz'];
    this.quiz_battel_result = quizDetail;
    this.student_tscore_result = quizDetail['student_tscore'];
    this.stList = quizDetail['student_detail'];
    // console.warn(this.student_tscore_result);
    // console.warn(this.stList);

    this.loading = false;
  }


  ops_quiz_event:any = { 'allst':0, 'come':0,'nocome':0 };
  stDetail;
  stNotToday;
  stToday;
  stListRoom;
  async quizStudentToday(){
    // alert('quizStudentToday');
    this.loading = true;
    this.showTeacher = false;

    let qid = this.qid;
    console.log('quizDetailToday: '+qid);

    let api = 't2/instructorQuizStudentToday';
    let url = this.URLAPI + api+'/'+qid;


    //{ withCredentials: true, credentials: 'include' }
    let response = await this._http
      .get(url, this.HTTPOPTION )
      .pipe()
      .toPromise();

      console.warn(response);
      let data = response['data'];
      let quiz = data['quiz'];

      let ops_quiz_event = quiz['ops_quiz_event'];
      this.ops_quiz_event = ops_quiz_event;
      let stDetail = quiz['stDetail'];
      this.stDetail = stDetail;
      let stNotToday = quiz['stNotToday'];
      this.stNotToday = stNotToday;
      let stToday = quiz['stToday'];
      this.stToday = stToday;
      this.stListRoom = quiz['stDetail'];
      this.loading = false;
  }


  stAnswer;
  seq;
  async studentwriting(i){
    // console.log('studentwriting');

    this.loading = true;
    let dataPost = this.quiz_detail[i];
    let qid = dataPost['quiz_id'];
    let seq = dataPost['seq'];
    this.seq  = seq;
    // console.warn(dataPost);

    let api = 't2/instructorQuizStudentAnswerWriting';
    let url = this.URLAPI + api+'/'+qid+'/'+seq;

    let response = await this._http
      .get(url, this.HTTPOPTION )
      .pipe()
      .toPromise();

    // let response = {"user":"morgan","data":{"qst":[{"sid":"20431","answer_text":"1","answer":"F","flag":false},{"sid":"21311","answer_text":"1","answer":"F","flag":false},{"sid":"21500","answer_text":"1","answer":"F","flag":false},{"sid":"21272","answer_text":"1","answer":"F","flag":false},{"sid":"20187","answer_text":"1","answer":"F","flag":false},{"sid":"21592","answer_text":"1","answer":"F","flag":false},{"sid":"21266","answer_text":"1","answer":"F","flag":false},{"sid":"21573","answer_text":"1","answer":"F","flag":false},{"sid":"21146","answer_text":"1","answer":"F","flag":false},{"sid":"21275","answer_text":"1","answer":"F","flag":false},{"sid":"21353","answer_text":"1","answer":"F","flag":false},{"sid":"20480","answer_text":"1","answer":"F","flag":false},{"sid":"21154","answer_text":"1","answer":"F","flag":false},{"sid":"20649","answer_text":"1","answer":"F","flag":false},{"sid":"19958","answer_text":"1","answer":"T","flag":true},{"sid":"19981","answer_text":"1","answer":"T","flag":true},{"sid":"21274","answer_text":"1","answer":"F","flag":false},{"sid":"21349","answer_text":"1","answer":"F","flag":false},{"sid":"20412","answer_text":"1","answer":"F","flag":false},{"sid":"21587","answer_text":"1","answer":"F","flag":false},{"sid":"20911","answer_text":"1","answer":"F","flag":false},{"sid":"21563","answer_text":"1","answer":"F","flag":false},{"sid":"21052","answer_text":"1","answer":"F","flag":false},{"sid":"21567","answer_text":"1","answer":"F","flag":false},{"sid":"20016","answer_text":"1","answer":"F","flag":false},{"sid":"21426","answer_text":"1","answer":"F","flag":false}]},"check":{"login":true,"user_id":"9163","user":"morgan","is_staff":"0","instructor_id":"25","fullname":"Ms.Morgan Calahan","nickname":"Morgan EP","sid":"morgan","ops_teacher_name":"t006"},"args":{"qid":"2096","qseq":"1"},"action":"T2instructorQuizStudentAnswerWritingAction"};

    console.warn(response);
    let data = response['data'];
    // let quiz = data['quiz'];
    this.stAnswer = data['qst'];
    this.i = i;
    // console.warn(data);
    this.loading = false;

  }

  i;
  async upScoreText(){
    console.warn('updateText');
    let stAnswer = this.stAnswer;
    let qid = this.qid;
    let seq = this.seq;

    // console.warn(stAnswer);

    this.loading = true;
    let api = 't2/instructorUpScoreText';
    let url = this.URLAPI + api;
    //{ withCredentials: true, credentials: 'include' }

    let dataPost = {st_answer: stAnswer, qid: qid, seq: seq}

    let response = await this._http
      .post(url, dataPost, this.HTTPOPTION )
      .pipe()
      .toPromise();

    this.loading = false;
    this.updateSolution(this.i);

    // data-toggle="modal" data-target=".modal-lg-resultSeq"



  }

  async quizExtra(){
    console.warn('quizExtra');
    await this.quizStudentToday();

    console.warn(this.stToday);



  }


  image_src:string;
  answer_image(image_src){
    // alert(image_src)
    this.image_src = image_src;
  }

  StartTimer(sec, index, ev){
    // console.warn('StartTimer' + sec);
    this.timer = setTimeout(x =>
      {
          sec -= 1;
          if(sec >= 0){
            this.StartTimer( sec, index, ev ); // นับต่อ
          } else {
              // นับเสร็จแล้ว
              this.quiz_detail[index]['letters'] = '';
              console.warn('Sent Update Flag');
              this.updateFlagOk(index, ev);
          }
      }, 1000);
      this.quiz_detail[index]['letters'] = sec;
  }


}